import React from 'react';

import PageTitle from '../common/PageTitle';
import SingleImport from '../common/SingleImport';

const ChestnyZnakImport = (props) => {
  return (
    <>
      <PageTitle title="Импорт пула номеров «Честный Знак»" />

      <SingleImport
        templateType="SKU"
        templateFileName="ItemTemplate"
        successMessage="Задание на импорт создано успешно"
        successRoute="/imports?import-chz"
        errorMessage="Ошибка создания задания на импорт"
        importType="chz"
      />
    </>
  );
};

export default ChestnyZnakImport;
